import { render, staticRenderFns } from "./transactionAdditionalFilters.vue?vue&type=template&id=29800748&"
import script from "./transactionAdditionalFilters.vue?vue&type=script&lang=js&"
export * from "./transactionAdditionalFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports